// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import L from 'leaflet'
import axios from 'axios'
import VueGeolocation from 'vue-browser-geolocation'

window.axios = axios

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.config.productionTip = false

Vue.use(VueGeolocation)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// Register service worker to control making site work offline
if ('serviceWorker' in navigator) {
  let thisurl = location.pathname
  let sw = thisurl + 'sw.js'
  navigator.serviceWorker
    .register(sw)
    .then(function () { console.log('Service Worker Registered') })
}



// WEBPACK FOOTER //
// ./src/main.js